import React from "react";
import ComingSoon from "components/admin/ComingSoon";

const AdminSignupRequests: React.FC = () => (
  <ComingSoon
    icon="👤"
    title="가입 요청 관리"
    features={[
      "가입 요청 목록 조회",
      "요청자 정보 및 소속 대학 확인",
      "가입 승인 · 거절 처리",
      "거절 사유 입력 및 안내",
      "승인 완료 계정 목록 조회",
    ]}
  />
);

export default AdminSignupRequests;
